import {
  IoAddOutline,
  IoBarcode,
  IoRefreshOutline,
  IoLogoBuffer,
  IoTrashOutline,
  IoEllipsisVertical,
  IoBusinessOutline,
  IoFilter,
  IoPersonRemoveOutline,
  IoDocumentTextOutline,
  IoQrCodeSharp,
} from "react-icons/io5";
import {
  VscClearAll,
  VscClose,
  VscSymbolConstant,
  VscPackage,
} from "react-icons/vsc";
import {
  MdHdrOffSelect,
  MdHdrOnSelect,
  MdOutlineFilePresent,
  MdOutlinePlaylistAddCheck,
  MdCameraswitch,
} from "react-icons/md";
import {
  RiFileExcel2Fill,
  RiAsterisk,
} from "react-icons/ri";
import {GoPackage} from "react-icons/go";
import {
  AiFillCamera,
  AiOutlineShoppingCart,
  AiOutlineFolderOpen,
  AiOutlinePrinter,
  AiOutlineMail,
  AiOutlineSolution,
  AiOutlineCheckCircle,
  AiOutlineExclamationCircle,
  AiOutlineInfoCircle,
  AiFillEdit,
  AiOutlineFileProtect,
  AiFillCopyrightCircle,
  AiOutlineMore,
  AiOutlineDollar,
} from "react-icons/ai";
import { BsList,  BsSkipForward } from "react-icons/bs";
import {
  CgPlayListRemove,
  CgListTree,
  CgSoftwareUpload,
  CgCodeSlash,
  CgArrowsExchangeAlt,
} from "react-icons/cg";
import { GiGraduateCap, GiDeerTrack } from "react-icons/gi";
import {
  MdOutlinePrecisionManufacturing,
  MdOutlineGetApp,
  MdOutlineLocalShipping,
  MdOutlineReceipt
} from "react-icons/md";
import { GoCommentDiscussion,GoLinkExternal } from "react-icons/go";
import { BiGitPullRequest, BiDevices } from "react-icons/bi";
import { FiMinimize, FiMaximize } from "react-icons/fi";
import { GrDocumentVerified } from "react-icons/gr";
import {
  FaArrowLeft,
  FaCheck,
  FaCodeBranch,
  FaDev,
  FaDiceD6,
  FaFolderOpen,
  FaHistory,
  FaEdit,
  FaIdCard,
  FaInbox,
  FaMinus,
  FaPencilAlt,
  FaPlus,
  FaRegBell,
  FaRegClipboard,
  FaSearch,
  FaSkull,
  FaStream,
  FaTrash,
  FaUser,
  FaUsers,
  FaUserShield,
  FaUpload,
  FaDownload,
  FaTimes,
  FaShoppingBag,
  FaStar
} from "react-icons/fa";
import { FiUserX } from "react-icons/fi";

import React from "react";
const _icon = (props) => {
  /* BI icons */
  if (props.bigitpullrequest || props.icon === "bigitpullrequest")
    return <BiGitPullRequest {...props} />;
  if (props.bidevices || props.icon === "BiDevices")
    return <BiDevices {...props} />;

  /* BS icons */
  if (props.fiminimize || props.icon === "fiminimize")
    return <FiMinimize {...props} />;
  if (props.fimaximize || props.icon === "fimaximize")
    return <FiMaximize {...props} />;

  /* FI icons */
  if (props.bslist || props.icon === "bslist") return <BsList {...props} />;
  if (props.bsskipforward || props.icon === "bsskipforward")
    return <BsSkipForward {...props} />;

    
    /* GO icons */
  if (props.gopackage || props.icon === "gopackage") return <GoPackage {...props} />;
  if (props.golinkexternal || props.icon === "golinkexternal") return <GoLinkExternal {...props} />;

  /* CG icons */
  if (props.cgplaylistremove || props.icon === "cgplaylistremove")
    return <CgPlayListRemove {...props} />;
  if (props.cglisttree || props.icon === "cglisttree")
    return <CgListTree {...props} />;
  if (props.cgsoftwareupload || props.icon === "cgsoftwareupload")
    return <CgSoftwareUpload {...props} />;
  if (props.cgcodeslash || props.icon === "cgcodeslash")
    return <CgCodeSlash {...props} />;
  if (props.cgarrowsexchangealt || props.icon === "cgarrowsexchangealt")
    return <CgArrowsExchangeAlt {...props} />;

  /* GO icons */
  if (props.gocommentdiscussion || props.icon === "gocommentdiscussion")
    return <GoCommentDiscussion {...props} />;

  /* AI icons  */
  
  if (props.aifillcamera || props.icon === "aifillcamera")
    return <AiFillCamera {...props} />;
  if (props.aioutlineinfocircle || props.icon === "aioutlineinfocircle")
    return <AiOutlineInfoCircle {...props} />;
    if (props.aioutlinefolderopen || props.icon === "aioutlinefolderopen")
    return <AiOutlineFolderOpen {...props} />;
    if (props.aioutlineprinter || props.icon === "aioutlineprinter")
    return <AiOutlinePrinter {...props} />;
    if (props.aioutlinesolution || props.icon === "aioutlinesolution")
    return <AiOutlineSolution {...props} />;
    if (props.aioutlinemail || props.icon === "aioutlinemail")
    return <AiOutlineMail {...props} />;
  if (
    props.aioutlineexclamationcircle ||
    props.icon === "aioutlineexclamationcircle"
  )
    return <AiOutlineExclamationCircle {...props} />;
  if (props.aioutlinecheckcircle || props.icon === "aioutlinecheckcircle")
    return <AiOutlineCheckCircle {...props} />;
  if (props.aioutlinefileprotect || props.icon === "aioutlinefileprotect")
    return <AiOutlineFileProtect {...props} />;
  if (props.aifilledit || props.icon === "aifilledit")
    return <AiFillEdit {...props} />;
  if (props.aifillcopyrightcircle || props.icon === "aifillcopyrightcircle")
    return <AiFillCopyrightCircle {...props} />;
  if (props.aioutlinemore || props.icon === "aioutlinemore")
    return <AiOutlineMore {...props} />;
    if (props.aioutlinedollar || props.icon === "aioutlinedollar")
    return <AiOutlineDollar {...props} />;
    if (props.aioutlineshoppingcart || props.icon === "aioutlineshoppingcart")
    return <AiOutlineShoppingCart {...props} />;
    

  /* MD icon */
  
  if (
    props.mdoutlineplaylistaddcheck ||
    props.icon === "mdoutlineplaylistaddcheck"
  )
    return <MdOutlinePlaylistAddCheck {...props} />;
    if (
      props.mdcameraswitch ||
      props.icon === "mdcameraswitch"
    )
      return <MdCameraswitch {...props} />;
  if (props.mdoutlinegetapp || props.icon === "mdoutlinegetapp")
    return <MdOutlineGetApp {...props} />;
    if (props.mdhdroffselect || props.icon === "mdhdroffselect")
    return <MdHdrOffSelect {...props} />;
    if (props.mdhdronselect || props.icon === "mdhdronselect")
    return <MdHdrOnSelect {...props} />;
    if (props.mdoutlinereceipt || props.icon === "mdoutlinereceipt")
    return <MdOutlineReceipt {...props} />;

  /* VSC icons */
  if (props.vscclearall || props.icon === "aioutlineinfocircle")
    return <VscClearAll {...props} />;
  if (props.vscsymbolconstant || props.icon === "vscsymbolconstant")
    return <VscSymbolConstant {...props} />;
    if (props.vscpackage || props.icon === "vscpackage")
    return <VscPackage {...props} />;
    

  /* IO5 icons */
  if (props.ioaddoutline || props.icon === "ioaddoutline")
    return <IoAddOutline {...props} />;
  if (props.iopersonremoveoutline || props.icon === "iopersonremoveoutline")
    return <IoPersonRemoveOutline {...props} />;
  if (props.iofilter || props.icon === "iofilter")
    return <IoFilter {...props} />;
  if (props.iodocumenttextoutline || props.icon === "iodocumenttextoutline")
    return <IoDocumentTextOutline {...props} />;
  if (props.ioellipsisvertical || props.icon === "ioellipsisvertical")
    return <IoEllipsisVertical {...props} />;
  if (props.iobusinessoutline || props.icon === "iobusinessoutline")
    return <IoBusinessOutline {...props} />;
  if (props.ioqrcodesharp || props.icon === "ioqrcodesharp")
    return <IoQrCodeSharp {...props} />;
  if (props.iologobuffer || props.icon === "iologobuffer")
    return <IoLogoBuffer {...props} />;
  if (props.iorefreshoutline || props.icon === "iorefreshoutline")
    return <IoRefreshOutline {...props} />;
  if (props.iobarcode || props.icon === "iobarcode")
    return <IoBarcode {...props} />;
    if (props.iotrashoutline || props.icon === "iotrashoutline")
    return <IoTrashOutline {...props} />;
    

  /* MD icons */
  if (
    props.mdoutlineprecisionmanufacturing ||
    props.icon === "mdoutlineprecisionmanufacturing"
  )
    return <MdOutlinePrecisionManufacturing {...props} />;
  if (props.mdoutlinefilepresent || props.icon === "mdoutlinefilepresent")
    return <MdOutlineFilePresent {...props} />;
  if (props.mdoutlinelocalshipping || props.icon === "mdoutlinelocalshipping")
    return <MdOutlineLocalShipping {...props} />;
    

  /* RI icons */
  if (props.rifileexcel2fill || props.icon === "rifileexcel2fill")
    return <RiFileExcel2Fill {...props} />;
  if (props.riasterisk || props.icon === "riasterisk")
    return <RiAsterisk {...props} />;

  /* FI icons */
  if (props.fiuserx || props.icon === "fiuserx") return <FiUserX {...props} />;

  /* Gi icons */
  if (props.gigraduatecap || props.icon === "gigraduatecap")
    return <GiGraduateCap {...props} />;
  if (props.gideertrack || props.icon === "gideertrack")
    return <GiDeerTrack {...props} />;

  /*  GR icons */
  if (props.grdocumentverified || props.icon === "grdocumentverified")
    return <GrDocumentVerified {...props} />;

  /* VSC icons */
  if (props.vscclose || props.icon === "vscclose")
    return <VscClose {...props} />;

  /* FA icons */
  if (props.fadev || props.icon === "fadev") return <FaDev {...props} />;
  if (props.faregbell || props.icon === "faregbell")
    return <FaRegBell {...props} />;
  if (props.facheck || props.icon === "facheck") return <FaCheck {...props} />;
  if (props.faskull || props.icon === "faskull") return <FaSkull {...props} />;
  if (props.fasearch || props.icon === "fasearch")
    return <FaSearch {...props} />;
  if (props.fausershield || props.icon === "fausershield")
    return <FaUserShield {...props} />;
  if (props.faarrowleft || props.icon === "faarrowleft")
    return <FaArrowLeft {...props} />;
  if (props.fahistory || props.icon === "fahistory")
    return <FaHistory {...props} />;
  if (props.faplus || props.icon === "faplus") return <FaPlus {...props} />;
  if (props.faminus || props.icon === "faminus") return <FaMinus {...props} />;
  if (props.fatrash || props.icon === "fatrash") return <FaTrash {...props} />;
  if (props.fastream || props.icon === "fastream")
    return <FaStream {...props} />;
  if (props.fafolderopen || props.icon === "fafolderopen")
    return <FaFolderOpen {...props} />;
  if (props.fapencilalt || props.icon === "fapencilalt")
    return <FaPencilAlt {...props} />;
  if (props.faidcard || props.icon === "faidcard")
    return <FaIdCard {...props} />;
  if (props.fausers || props.icon === "fausers") return <FaUsers {...props} />;
  if (props.fatimes || props.icon === "fatimes") return <FaTimes {...props} />;
  if (props.fadiced6 || props.icon === "fadiced6")
    return <FaDiceD6 {...props} />;
  if (props.facodebranch || props.icon === "facodebranch")
    return <FaCodeBranch {...props} />;
  if (props.fainbox || props.icon === "fainbox") return <FaInbox {...props} />;
  if (props.faupload || props.icon === "faupload")
    return <FaUpload {...props} />;
  if (props.fadownload || props.icon === "fadownload")
    return <FaDownload {...props} />;
  if (props.faregclipboard || props.icon === "faregclipboard")
    return <FaRegClipboard {...props} />;
  if (props.fauser || props.icon === "fauser") return <FaUser {...props} />;
  if (props.faedit || props.icon === "faedit") return <FaEdit {...props} />;
  if (props.facartshopping || props.icon === "facartshopping") return <FaShoppingBag {...props} />;
  if (props.fastar || props.icon === "fastar") return <FaStar {...props} />;
  
};

export default _icon;
